
import { BaseConfig } from './base-config.service';
import { WebApiClient } from './web-api-client.service';
import { WebApiService } from './web-api.service';
import { WholeHist } from  'src/app/services/api-service/hist/whole-hist';
import { Clinic } from 'src/app/system/clinic/models/clinic';
import { Observable, of } from 'rxjs';
import { Injectable } from '@angular/core';

import { UserCache } from './user-cache';
import { EasyNotificationService } from './easy-notification.service';
import { WebPrintService } from './web-print.service';
import { HcrService } from './hcr-service.service';
import { IBaseConfig } from '../shared/models/base-config';
import { DateHelper } from '../shared/helpers/date-helper';
import { PatientApi } from './api-service/patient/patient-api';
import { PatientsDto } from './api-service/patient/patientsDto';
import { GetHtmlParamter, ReportHelperComponent } from '../system/report/report-helper/report-helper.component';
import { HistApi } from './api-service/hist/hist-api';
import { ClinicDataService } from './data-service/clinic-data-service';
import { PRN001Params } from './api-service/parameters/PRN001Params';
import { HistOrder } from '../hist/models/hist-order';
import { ValueTextPair } from '../shared/models/value-text-pair';
import { SessionService } from './session.service';
import { RegisterApi } from './api-service/register/register-api';

@Injectable({
  providedIn: 'root'
})
export class LocalPrintService {

  get printHelper():ReportHelperComponent{
    return ReportHelperComponent.Instance;
  }
  config: IBaseConfig;
  private notification: EasyNotificationService;
  //private api: WebApiService;
  private hisApi: WebApiService;
  // debug模式先關閉送印
  enablePrinter = true;
  param: PRN001Params;
  private paramArr: ValueTextPair[] = [];
  private additionPrintSetting = '';
  private useOutVisit = false;
  private useOutVisitJail = false;

  constructor(
    private webApiClient: WebApiClient,
    private notificationDI: EasyNotificationService,
    private webPrintService: WebPrintService,
    private patientApi: PatientApi,
    private histApi:HistApi,
    private sessionService: SessionService,
    private clinicDataService: ClinicDataService,
    private regApi: RegisterApi,
    private hcrService: HcrService) {
    this.config = BaseConfig.getConfig();
    this.notification = notificationDI;
    this.hcrService.SetPrintService(this);
  }

  private readonly reportType_register = 'Register';
  private readonly reportType_receipt = 'Receipt';
  private readonly reportType_rx = 'Rx';
  private readonly reportType_history = 'History';
  private readonly reportType_inject = 'Injection';
  private readonly reportType_lab = 'Lab';

  /** 列印 一般處方 */
  public async printPrescription(regId:number) {
    if (this.param.DoubleSidedPrintType != 1) {
      await this.printHelper.print(regId, [1]);
    }
  }

  /** 列印收據 明細 */
  public async printReceipt(regId) {
    await this.printHelper.print(regId, [2]);
  }

  /** 列印服法收據 */
  public async printWay(regId) {
    await this.printHelper.print(regId, [3]);
  }

  /** 列印交付連處 5 */
  public async printRepeatPres(regId,pres:number = null) {
    await this.printHelper.getPrePrint(regId, 5);
    if(pres)
    {
      var getHtmlParamter = new GetHtmlParamter();
      getHtmlParamter.CurrentPres = pres;
      await this.printHelper.print(regId, [5],getHtmlParamter);
    }
    else
      await this.printHelper.print(regId, [5]);
  }

  /**
   * 依 P.37 與 IsPrintAfterSevenDispPrescription 決定交付連處要印幾張、
   * 是否逐張拆分慢籤日期區間、是否加印 /7 以下醫令，逐張呼叫 printRepeatPres。
   * cntPresTot 由呼叫端傳入（呼叫端本來就已持有該筆病歷資料），本函式不重新查詢。
   * 最外層只依 P.37 分「空 / 1~3 / z」三類；是否慢箋（cntPresTot 是否有值）對 /7 加印與張數的
   * 影響在各類別內處理，因為同一個 P.37 值在慢箋與非慢箋底下代表的意義不同。
   * 三類以外的 P.37 值視為參數設定錯誤，不列印並提示，不做退回單張的猜測。
   * 回傳是否有實際送印；呼叫端據此決定要不要顯示列印完成訊息，未印時本函式已自行提示原因。
   */
  public async printRepeatPresBatch(regId: number, cntPresTot: string): Promise<boolean> {
    const isPrintAfterSeven = this.param?.IsPrintAfterSevenDispPrescription ?? true;
    const opt = await this.histApi.getEditOptions();
    const p37 = opt?.p37?.trim().toLowerCase() ?? '';
    const isChronic = !!cntPresTot;

    if (p37 === '') {
      // 空：不論是否慢箋，只印 1 張；/7 是否加印比照 IsPrintAfterSevenDispPrescription
      // （非慢箋本來就不會有 /7 段落，isPrintSeven 對它不生效，設定與否無影響）
      this.regApi.isPrintSeven = isPrintAfterSeven;
      await this.printRepeatPres(regId);
    } else if (/^[1-3]$/.test(p37)) {
      // 1/2/3：純重複列印 1+n 張相同內容，不拆分日期；不論是否慢箋都照樣多印，每張皆加印 /7
      const copies = 1 + parseInt(p37);
      this.regApi.isPrintSeven = isPrintAfterSeven;
      for (var i = 1; i <= copies; i++) {
        await this.printRepeatPres(regId);
      }
    } else if (p37 === 'z') {
      // z：僅慢箋有意義，依 cntPresTot 慢籤次數逐張印並拆分對應日期區間，只有第 1 張加印 /7；
      // 非慢箋（cntPresTot 空）沒有可拆分的次數，退化為印 1 張
      if (!isChronic) {
        await this.printRepeatPres(regId);
      } else {
        const count = parseInt(cntPresTot);
        for (var i = 1; i <= count; i++) {
          this.regApi.isPrintSeven = isPrintAfterSeven && i === 1;
          await this.printRepeatPres(regId, i);
        }
      }
    } else {
      // 無法解析的 P.37 值代表參數設定錯誤，不列印：張數無從判定，印錯張數比不印更難察覺
      console.log('P.37 參數值無法解析，交付調劑處方箋不予列印:', p37);
      this.notification.showError(`交付調劑處方箋列印張數參數（P.37）設定值「${p37}」無法辨識，本次未列印，請確認參數設定`);
      return false;
    }
    return true;
  }

  /** 列印交付檢驗單 6 */
  public async printLabOutClinic(regId) {
    // await this.printHelper.getPrePrint(regId, 6);
    await this.printHelper.print(regId, [6]);
  }

  /** 列印藥袋 */
  public async printDrugbag(regId, rxIdList: HistOrder[] = []) {
    this.printHelper.drugBagRxIdList = rxIdList;
    await this.printHelper.print(regId, [7]);
  }

  /** 列印藥袋 - 自訂分袋版本 */
  public async printDrugbagWithCustomBag(regId: number, rxIdList: HistOrder[] = [], customBagRules: any[] = []) {
    this.printHelper.drugBagRxIdList = rxIdList;
    // 將自訂分袋規則傳遞給 printHelper
    this.printHelper.customBagRules = customBagRules;
    await this.printHelper.print(regId, [7]);
  }

  /** 列印交付連處 測試  81 */
  public async printRepeatPresTest(regId) {
    await this.printHelper.getPrePrint(regId, 81);
    await this.printHelper.print(regId, [81]);
  }
  /** 列印 掛號單 101 */
  public async printRegisterForm(regId:number) {
    await this.printHelper.print(regId, [101]);
  }
  /** 列印 欠卡單(押金單) 810 */
  public async printArrearReceipt(regId:number) {
    await this.printHelper.print(regId, [810]);
  }

  // 列印病歷
  public printHistory(regId:number) {
    this.printHelper.print(regId, [1]);
  }

  // 列印注射單
  public printInjectionForm(wholeHist: WholeHist) {
    this.printHistoryLike(wholeHist, this.reportType_inject);
  }

  // 列印院內檢驗單
  public printLabForm(wholeHist: WholeHist) {
    this.printHistoryLike(wholeHist, this.reportType_lab);
  }

  // 列印管制藥品處方箋
  public printCtrdrugs(regId:number){
    //this.getCtrdrugs(regId);
    this.printHelper.print(regId, [809]);
  }

   // 列印注射單
  public printInjectionForm2(regId: number) {
    this.printHelper.print(regId, [815]);
   // return this.printHelper.getHtml(regId,815);
  }

  /** 取得 一般處方 的 html */
  public getPrescription(regId: number) {
    return this.printHelper.getHtml(regId, 1);
  }

  /** 取得 收據 明細 的 html*/
  public getReceipt(regId: number) {
    return this.printHelper.getHtml(regId, 2);
  }

  /** 取得 藥袋 的 html*/
  public async getDrugbag(regId: number) {
    return this.printHelper.getHtml(regId, 7);
  }

  /** 取得 藥袋 的 html - 自訂分袋版本 */
  public async getDrugbagWithCustomBag(regId: number, customBagRules: any[] = []) {
    this.printHelper.customBagRules = customBagRules;
    return this.printHelper.getHtml(regId, 7);
  }

  /** 取得 交付連處 的 html */
  public getRepeatPres(regId: number) {
    return this.printHelper.getHtml(regId, 5);
  }

  /** 取得 掛號單 的 html */
  public getRegisterForm(regId: number) {
    return this.printHelper.getHtml(regId, 101);
  }

  /** 取的 管制藥品處方箋的 html */
  public getCtrdrugs(regId:number){
    return this.printHelper.getHtml(regId,809);
  }

  /** 取的 押金單的 html */
  public getArrearReceipt(regId:number){
    return this.printHelper.getHtml(regId,810);
  }

  // 列印病歷
  // public 取得History(regId: number) {
  //   this.printHelper.getHtml(regId, [1]);
  // }

  // ------------------------------------

  private printHistoryLike(hist: WholeHist, reportType: string) {
    const register = hist.Register;
    const patient = hist.Patient;
    const history = hist.Hist;
    const prescriptionData = {
      HistoryMaster: {
        PatientName: patient.CName,
        SexName: patient.SexName,
        CId: patient.CId,
        BirthDay: DateHelper.formatDate(patient.Birthday),
        PatientNo: patient.PatientNo,
        DoctorName: register.DoctorName,
        RegDate: DateHelper.formatDate(register.RegDate),
        ICode: register.ICode,
        PharmacistName: history.PharmacistName,
        CC: history.CC,
        PE: history.PE,
        Diagnosis1: history.Dx1,
        Diagnosis1Name: history.Dx1Name,
        Diagnosis2: history.Dx2,
        Diagnosis2Name: history.Dx2Name,
        ClinicName: '',
        ClinicPhone: '',
        ClinicFax: '',
        ClinicAddress: '',
      },
      HistoryDetails: []
    };
    // 資料分類過濾的部分做在pres-print.service內
    // if (reportType === this.reportType_rx) {
    //   hist.Hist.Orders = hist.Hist.Orders.filter(x =>
    //     x.NhiDrugType === NhiDrugTypeEnum.Oral ||
    //     x.NhiDrugType === NhiDrugTypeEnum.ExternalUse ||
    //     x.NhiDrugType === NhiDrugTypeEnum.ChineseSoap ||
    //     x.NhiDrugType === NhiDrugTypeEnum.ChineseMedicine);
    // } else if (reportType === this.reportType_lab) {
    //   hist.Hist.Orders = hist.Hist.Orders.filter(x =>
    //     x.NhiDrugType === NhiDrugTypeEnum.Lab ||
    //     x.NhiDrugType === NhiDrugTypeEnum.XRay);
    // } else if (reportType === this.reportType_inject) {
    //   hist.Hist.Orders = hist.Hist.Orders.filter(x =>
    //     x.NhiDrugType === NhiDrugTypeEnum.Injection);
    // }
    // 所有調劑先都印，後面再來改
    hist.Hist.HRxs.forEach((order, index) => {
      const prescriptionDetail = {
        Id: index + 1,
        DrugCode: order.RxCode,
        DrugName: order.ProdName,
        Dose: order.Dose,
        EnterUnit: order.Unit,
        Frequency: order.Freq,
        Way: order.Way,
        Days: order.Days,
        TotalDose: order.TotalDose,
        Remark: order.Remark
      };
      prescriptionData.HistoryDetails.push(prescriptionDetail);
    });
    const cln = UserCache.getLoginUser().Clinic;
    prescriptionData.HistoryMaster.ClinicName = cln.Name;
    prescriptionData.HistoryMaster.ClinicPhone = cln.Phone;
    prescriptionData.HistoryMaster.ClinicFax = cln.Fax;
    prescriptionData.HistoryMaster.ClinicAddress = cln.Street;
    //this.sendToPrinter(reportType, prescriptionData);
  }


  /** 送列印排程 */
  public async printHtml(tp: number, name: string, content: string,subPrinter:number[]=null) {
    // console.log(name + ' 送印中');
    return await this.hcrService.Print(tp, {
      PrintHtml: true,
      ReportName: name,
      Html: content
    },subPrinter);
  }

  public async printText(tp: number, name: string, content: string) {
    return await this.hcrService.Print(tp, {
      PrintHtml: false,
      ReportName: name,
      Html: content
    });
  }

  // ------------------------------------

  public async initialPrintClient(): Promise<Observable<any>> {
    // 在login呼叫時可能尚未即時取得config，所以這裡再抓一次
    this.config = BaseConfig.getConfig();
    if (!this.config.localPrint.isRunLocalReport) {
      return of();
    }
    this.useOutVisit = this.sessionService.getData('useOutVisit');
    this.useOutVisitJail = this.sessionService.getData('useOutVisitJail');
    this.additionPrintSetting = this.sessionService.getData('additionPrintSetting');
    this.param = await this.clinicDataService.getParam("PRN001");
    if (this.useOutVisit || this.useOutVisitJail) {   // 巡診並另外設定列印參數
      if (this.additionPrintSetting) {
        var oriParam = this.additionPrintSetting.replace(/\ /g, '').replace(/\{/g, '').replace(/\}/g, '').replace(/\"/g,'');
        const strs = oriParam.split(',');
        strs.forEach(str => {
          const data = new ValueTextPair();
          if(str.indexOf(':')>0){
            data.text = str.split(':')[0];
            data.value = str.split(':')[1];
          } else {
            data.text = str;
            data.value = str;
          }
          this.paramArr.push(data);
        });
        var recCode = this.paramArr.find(x => x.text == 'DoubleSidedPrintType').value;
        if (recCode.length > 0) this.param.DoubleSidedPrintType = Number(recCode);
      }
    }
  }
  // private sendToPrinter(reportName: string, data: any, forceInitial: boolean = true) {
  //   this.config = BaseConfig.getConfig();
  //   if (this.config.localPrint.isRunLocalReport) {
  //     if (this.api == null) {
  //       this.api = this.webApiClient.createLocalPrintService('/report/');
  //     }
  //     // 送本機列印程式
  //     this.api.post(reportName, data).subscribe((result: any) => {
  //     }, error => {
  //       // REP001：未完成初始化(需要傳LoginUser參數給winform)
  //       if (error.code === 'REP001' && forceInitial) {
  //         this.initialPrintClient().subscribe(result => {
  //           this.sendToPrinter(reportName, data, false);
  //         });
  //       } else {
  //         this.notification.showWarning('local print failed');
  //       }
  //     });
  //   }

  //   // 送遠端列印伺服器
  //   this.sendToRemotePrintServer(reportName, data);
  //   // 用網頁列印方式
  //   this.doWebPrint(reportName, data);
  // }
  private sendToRemotePrintServer(reportName: string, data: any) {
    if (!this.config.localPrint.isEnableRemotePrint) {
      return;
    }

    const keys = ['companyCode', 'clinicCode', 'reportName', 'printData'];
    const user = UserCache.getLoginUser();
    const values = [user.CompanyCode, user.Clinic.Code, reportName, JSON.stringify(data)];
    // this.OpenWindowWithPost(this.config.localPrint.remoteReportServer, 'RemotePrintWindow', keys, values);
    this.OpenWindowWithPost(this.config.localPrint.remoteReportServer, reportName, keys, values);
  }

  private doWebPrint(reportName: string, data: any) {
    if (!this.config.localPrint.isEnableWebPrint) {
      return;
    }
    if (reportName === this.reportType_register) {
      this.webPrintService.printRegisterForm(data.RegisterReport);
    }
  }

  OpenWindowWithPost(url, name, keys, values) {
    const form = document.createElement('form');
    form.setAttribute('method', 'post');
    form.setAttribute('action', url);
    form.setAttribute('target', name);
    for (let i = 0; i < keys.length; i++) {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = keys[i];
      input.value = values[i];
      form.appendChild(input);
    }
    document.body.appendChild(form);
    window.open(url, `${name}`);
    form.submit();
    document.body.removeChild(form);
  }

  private async getPatientData(patientId: number): Promise<PatientsDto> {
    return await this.patientApi.Get(patientId);
  }

  private getClinicData(clinicId: number): Observable<Clinic> {
    if (this.hisApi == null) {
      this.hisApi = this.webApiClient.createHisService('');
    }
    this.hisApi.basePath = 'system/clinic';
    return this.hisApi.get('get/' + clinicId);
  }
}

class RegisterForm{
  patNumber:string;
  patName:string;
  age:number;
  regDate:string;
  tsec:string;
  room:string;
  doctorName:string;
  waitNo:string;
  remark:string;
  clinicAddress:string;
  clinicTel:string;
}
